import { render } from "./ViewInternEvaluationDialog.vue?vue&type=template&id=ef336ba8&scoped=true"
import script from "./ViewInternEvaluationDialog.vue?vue&type=script&lang=js"
export * from "./ViewInternEvaluationDialog.vue?vue&type=script&lang=js"

import "./ViewInternEvaluationDialog.vue?vue&type=style&index=0&id=ef336ba8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef336ba8"]])

export default __exports__